import {
  CreateUnnamedOverlayRequest,
  GetUnnamedOverlayResponse,
  UnnamedOverlay,
} from '@fullstory/proto/fs/services/dx-objects';
import { createRequestReducer, DispatchedAction, RequestAction } from '@fullstory/redux-util';
import { isEqual } from 'lodash';
import { Action, combineReducers } from 'redux';
import { OverlayRequestTypes } from './types';

export const defaultOverlayState: UnnamedOverlay = {
  id: '',
  segments: [],
  deps: [],
  timeRange: null,
};
type UnnamedOverlayState = { [hash: string]: UnnamedOverlay };

const unnamedOverlayRequests = createRequestReducer<UnnamedOverlayState, GetUnnamedOverlayResponse>(
  {
    mergeData: (state, update) => {
      const { overlay } = update;
      if (!overlay) return state;

      return {
        ...state,
        [overlay.id]: overlay,
      };
    },
  },
)(
  OverlayRequestTypes.GetUnnamedOverlayRequest,
  OverlayRequestTypes.GetUnnamedOverlaySuccess,
  OverlayRequestTypes.GetUnnamedOverlayFailure,
);

type CreateUnnamedMetricRequestAction = RequestAction<
  OverlayRequestTypes.CreateUnnamedOverlayRequest,
  CreateUnnamedOverlayRequest
>;

const isCreateOverlayRequestAction = (action: Action): action is CreateUnnamedMetricRequestAction =>
  action.type === OverlayRequestTypes.CreateUnnamedOverlayRequest;

type UnnamedOverlayRequestState = ReturnType<typeof unnamedOverlayRequests>;

const unnamedOverlay = (
  state: UnnamedOverlayRequestState = {
    lastRequested: -1,
    lastResponded: -1,
    loading: false,
    error: false,
    data: {},
    safeMessage: null,
  },
  action: CreateUnnamedMetricRequestAction | DispatchedAction<any, any, any, any, any>,
): UnnamedOverlayRequestState => {
  if (isCreateOverlayRequestAction(action)) {
    if (!action.body || !action.body.overlay) return state;

    // don't overwrite an identical overlay, this way we maintain stable references
    // even if create is called multiple times on the same overlay
    if (
      state.data &&
      state.data[action.body.hash] &&
      isEqual(state.data[action.body.hash], action.body.overlay)
    ) {
      return state;
    }

    return {
      ...state,
      data: {
        ...state.data,
        [action.body.hash]: action.body.overlay,
      },
    };
  }
  return unnamedOverlayRequests(state, action);
};

type UnnamedOverlayReducer = {
  unnamedOverlay: ReturnType<typeof unnamedOverlay>;
};
export const unnamedOverlayReducer = combineReducers<UnnamedOverlayReducer>({
  unnamedOverlay,
});
